import React from 'react'

export class ChatwootWidget extends React.Component {
  componentDidMount() {
    // Add Chatwoot Settings
    window.chatwootSettings = {
      hideMessageBubble: true,
      position: 'right', // This can be left or right
      locale: 'en', // Language to be set
      type: 'standard', // [standard, expanded_bubble]

      //  showUnreadMessagesDialog: false,
      //  showPopoutButton: false,
    }
    ;(function (d, t) {
      var BASE_URL = 'https://app.chatwoot.com'
      var g = d.createElement(t) as any,
        s = d.getElementsByTagName(t)[0] as any
      g.src = BASE_URL + '/packs/js/sdk.js'
      s.parentNode.insertBefore(g, s)
      g.async = !0
      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: '3SyydmALGUM7QNvEnVV1t8et',
          baseUrl: BASE_URL,
        })
      }
    })(document, 'script')
  }

  render() {
    return null
  }
}
